import apiService from '@/services/apiService';

const getDefaultState = () => {
  return {
    userInfoRegister: {},
    infoRegisterNewUser: {},
  }
};
const state = getDefaultState();

const mutations = {
  SET_USER_INFO_REGISTER (state, payload) {
    state.userInfoRegister = payload;
  },
  SET_INFO_REGISTER_NEW_USER (state, payload) {
    state.infoRegisterNewUser = payload;
  },
};

const actions = {
  async getPreUserInfoRegister ({commit}, payload) {
    const result = await apiService.post(payload.url, payload.params)
    commit('SET_USER_INFO_REGISTER', {token: result.data.token, mail: result.data.mail});

    return result.data.code;
  },
  async registUserInfo ({commit}, payload) {
    const result = await apiService.post(payload.url, payload.params)
    return result.data;
  },
};

export default {
  state, mutations, actions
};



// WEBPACK FOOTER //
// ./src/stores/modules/registerStore.js